import {IListProductsResultEntry} from "admins-dashboard/http-clients/index";

export const productSerialNumberPipe = (device: IListProductsResultEntry): string | null | undefined => {
    if (device) {
        return device.productSerialNumber;
    }
    return undefined
};
